module.exports = __webpack_public_path__ + "img/fringe-5in-bullion.b70df173.jpg";